exports.API_URL = process.env.NODE_ENV === "production" ? "https://jscrunch-api.herokuapp.com" : "http://localhost:3001";
exports.SERVER_AUTH = process.env.NODE_ENV === "production" ? "http://jscrunch.com" : "http://localhost:4000";

exports.STRIPE_PUBLISHABLE_KEY = process.env.NODE_ENV === "production" ? process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY :
    "pk_test_51H1dMEFZOor53AJPuTG9Hj5VuSpGZFHni0FGgTJcHpo9yxiSLyNiEkSAR4gkCZOGHnhgQrVYL4Nm6EcsBwARpvtv009ExdzP6E";
